import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ai-explanation-snack',
  imports: [TranslatePipe],
  template: `
    <div class="ai-explanation-snack">
      <svg class="snack-icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5m0-8h.01" />
      </svg>
      <span class="snack-message">{{ 'aiExplanation.txtInfo' | translate }}</span>
      <svg class="snack-icon network_intel_node" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M323-160q-11 0-20.5-5.5T288-181l-78-139h58l40 80h92v-40h-68l-40-80H188l-57-100q-2-5-3.5-10t-1.5-10q0-4 5-20l57-100h104l40-80h68v-40h-92l-40 80h-58l78-139q5-10 14.5-15.5T323-800h97q17 0 28.5 11.5T460-760v160h-60l-40 40h100v120h-88l-40-80h-92l-40 40h108l40 80h112v200q0 17-11.5 28.5T420-160h-97Zm180.5-23.5Q480-207 480-240q0-23 11-40.5t29-28.5v-342q-18-11-29-28.5T480-720q0-33 23.5-56.5T560-800q33 0 56.5 23.5T640-720q0 23-11 40.5T600-651v101l80-48q0-34 23.5-58t56.5-24q33 0 56.5 23.5T840-600q0 33-23.5 56.5T760-520q-11 0-20.5-2.5T721-530l-91 55 101 80q7-3 14-4t15-1q33 0 56.5 23.5T840-320q0 33-23.5 56.5T760-240q-37 0-60.5-28T681-332l-81-65v89q18 11 28.5 28.5T639-240q0 33-23 56.5T560-160q-33 0-56.5-23.5Z"/></svg>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }

    .ai-explanation-snack {
      align-items: center;
      color: #262626;
      display: flex;
      gap: 12px;
      justify-content: space-between;
      min-height: 48px;
      width: 100%;
    }

    .snack-icon {
      fill: none;
      flex: 0 0 24px;
      height: 24px;
      stroke: #000000;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 1.8;
      width: 24px;
    }

    .snack-icon.network_intel_node{
      fill: #71C55D;
    }

    .snack-message {
      flex: 1;
      font-family: Inter;
      font-weight: 500;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #232323;
      text-align: center;
    }
    @media screen and (min-width: 1200px) and (max-width: 1919px) {
       .ai-explanation-snack {
        gap: 0.625vw;
        min-height: 2.5vw;
      }

      .snack-icon {
        fill: none;
        flex: 0 0 1.25vw;
        height: 1.25vw;
        width: 1.25vw;
      }


      .snack-message {
        font-size: 0.833vw;
      }
    }
    @media screen and (min-width: 768px) and (max-width: 1199.99px) {
      .ai-explanation-snack {
        gap: 7.8px;
        min-height: 30px;
      }

      .snack-icon {
        fill: none;
        flex: 0 0 15px;
        height: 15px;
        width: 15px;
      }


      .snack-message {
        font-size: 10px;
      }
    }

    @media screen and (max-width: 767.99px){
      .ai-explanation-snack {
        flex-wrap: wrap-reverse;
        justify-content: center;
        height: auto;
        padding: 10px 0;
      }
      .snack-message {
        flex: none;
      }
    }

  `]
})
export class AiExplanationSnack {}
